import ReactGA from 'react-ga';

const trackingId = 'UA-167141062-1';
const analyticsConfig = {
  debug: true,
};

let isInit = false;

export function initAnalytics() {
  isInit = true;
  ReactGA.initialize(trackingId, analyticsConfig);
}

export function trackPage(path, title) {
  if (!isInit) return;
  ReactGA.pageview(path, null, title);
}

export function trackModal(modalName) {
  if (!isInit) return;
  ReactGA.modalview(modalName);
};

export function trackUserEvent(category, action, params) {
  if (!isInit) return;
  ReactGA.event({
    category,
    action,
    nonInteraction: false,
    ...params,
  });
};

export function trackSystemEvent(category, action, params) {
  if (!isInit) return;
  ReactGA.event({
    category,
    action,
    nonInteraction: true,
    ...params,
  });
};

export function trackExternalLink(url) {
  if (!isInit) return;
  ReactGA.outboundLink({ label: url });
};

export function trackException(description, fatal = false) {
  if (!isInit) return;
  ReactGA.exception({ description, fatal });
};
